import { useState } from 'react';
import { heroStats } from '@/mocks/home';

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const [hint, setHint] = useState('');

  const handleSearch = () => {
    const value = keyword.trim();
    if (!value) {
      setHint('先输入一个事件名或关键词，例如「星野文化」。');
      return;
    }
    setHint(`演示站点：检索暂未接入，可直接在下方时间线按节点查看「${value}」的来龙去脉。`);
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20texture%20of%20layered%20warm%20crimson%20and%20deep%20amber%20ink%20washes%20on%20charcoal%20paper%2C%20soft%20grain%2C%20slow%20diffused%20light%2C%20no%20text%2C%20moody%20investigative%20atmosphere%2C%20cinematic%20negative%20space%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=kd-hero-01&orientation=landscape"
          alt="蝌蚪黑料时间线背景图，暖色调抽象墨迹纹理"
          title="蝌蚪黑料 时间线 来龙去脉"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28 lg:py-32">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-background-50/25 px-4 py-1.5 font-label text-xs tracking-[0.2em] text-background-100">
          <i className="ri-git-commit-line text-sm text-accent-400" />
          源头 · 节点 · 走向
        </span>

        <h2 className="w-full max-w-3xl font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          把只<span className="text-accent-400">刷到一半</span>的瓜，
          <br className="hidden sm:block" />
          从头补到完整走向
        </h2>

        <p className="mt-6 w-full max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          蝌蚪黑料把每个事件的源头、节点顺序和后续走向排成一条线，
          点开就能看到前因后果与层层分析，适合补全你只刷到一半的那部分。
        </p>

        <div className="mt-9 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
          <div className="flex flex-1 items-center gap-2 rounded-md border border-background-50/25 bg-background-50/10 px-4 py-3 backdrop-blur">
            <i className="ri-search-line text-base text-background-200" />
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleSearch();
                }
              }}
              placeholder="输入事件名或关键词，直达它的时间线"
              className="w-full bg-transparent text-sm text-background-50 placeholder:text-background-300 focus:outline-none"
            />
          </div>
          <button
            type="button"
            onClick={handleSearch}
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
          >
            开始梳理
            <i className="ri-arrow-right-line text-base" />
          </button>
        </div>

        {hint ? (
          <p className="mt-4 w-full max-w-xl rounded-md bg-background-50/10 px-4 py-2 text-xs text-background-100">
            {hint}
          </p>
        ) : null}

        <dl className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-6 border-t border-background-50/15 pt-8 md:grid-cols-4 md:gap-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex flex-col text-center">
              <dt className="order-2 mt-1 font-label text-xs tracking-wide text-background-300">
                {stat.label}
              </dt>
              <dd className="font-heading text-2xl text-background-50 md:text-3xl">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}